import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {UpdateUserMfaSettingsResultModal} from './update-mfa.result.modal';
import {
    clearResult,
    selectUpdateMfaSettingsShown,
    selectUpdateMfaSettingsTask,
    selectUpdateMfaSettingsUuid,
} from './update-mfa.slice';


export const UpdateMfaResult = () => (
    <BulkActionResult
        actionIdSelector={selectUpdateMfaSettingsUuid}
        actionTaskSelector={selectUpdateMfaSettingsTask}
        actionShownSelector={selectUpdateMfaSettingsShown}
        clearResult={clearResult}>
        {({id, onClose}) => <UpdateUserMfaSettingsResultModal id={id} onClose={onClose}/>}
    </BulkActionResult>
);
